import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';
import { ChevronRight, Sparkles } from 'lucide-react';

const AgentBI = () => {
  const { t } = useLanguage();
  usePageTitle('Agent BI');
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-x-hidden">
      <section className="relative pt-28 pb-12 sm:pt-36 sm:pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-2xl rounded-xl overflow-hidden border border-dark-border bg-dark-card mb-8 shadow-lg">
            <video
              controls
              playsInline
              className="w-full aspect-video object-cover"
              poster="/images/agent-bi-card.png"
              onError={() => setVideoError(true)}
              onLoadedData={() => setVideoError(false)}
            >
              <source src="/videos/agent-bi-demo.mp4" type="video/mp4" />
              <source src="/videos/agent-bi-demo.mov" type="video/quicktime" />
              {t('agentBiPage.videoUnsupported')}
            </video>
            {videoError && (
              <p className="text-sm text-gray-500 px-4 py-3 bg-dark-surface/50 border-t border-dark-border">
                {t('agentBiPage.videoLoadHint')}
              </p>
            )}
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-4 text-white flex items-center gap-2">
            <Sparkles className="h-6 w-6 sm:h-7 sm:w-7 text-accent flex-shrink-0" />
            {t('agentBiPage.title')}
          </h1>
          <p className="text-base md:text-lg text-gray-400 leading-relaxed mb-6">
            {t('agentBiPage.body')}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/#projects"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-accent font-medium text-sm rounded-full border border-accent/30 hover:bg-accent/10 transition-all duration-300"
            >
              {t('agentBiPage.backToProjects')} <ChevronRight className="h-4 w-4" />
            </Link>
            <Link
              to="/careers"
              className="shimmer-wrap inline-flex items-center gap-2 px-5 py-2.5 text-gray-300 font-medium text-sm rounded-full border border-white/[0.12] hover:bg-white/[0.06] hover:border-white/25 hover:text-white transition-all duration-300"
            >
              {t('footer.about.join')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AgentBI;
